module.exports = __webpack_public_path__ + "img/3.2.93e8a9f5.svg";